/**
 * Created by pc on 2018/12/22.
 */

import { post } from '../../http/index';
import { BASE_URL } from '@/global/util/constants';
import qs from 'qs';
import Page from '@/global/util/Page';

const MANAGER_FINANCIAL_DETAILS_MENU = 'MANAGER_FINANCIAL_DETAILS_MENU'; // 财务管理明细类别
const MANAGER_FINANCIAL_DETAILS_TABLE = 'MANAGER_FINANCIAL_DETAILS_TABLE'; // 财务管理明表格

const state = {
  financial: {
    detailsTypeMenu: [],
    curDetailsType: '',
    detailsPage: new Page(),
    detailsDown: ''
  }
};

const getters = {
  financial: state => state.financial
};

const actions = {
  async getFinDetailsTypeMenu ({ commit, state }, { userType } = {}) {
    await post('/ad-user/finance/type', { user_type: userType }).then(res => {
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_DETAILS_MENU, res.data);
      }
    });
  },
  getFinDetailsTable (
    { commit, state },
    {
      startTime,
      endTime,
      userId,
      type,
      pageSize = state.financial.detailsPage.pageSize,
      currentPage = state.financial.detailsPage.currentPage
    }
  ) {
    let params = {};
    params.start_time = startTime;
    params.end_time = endTime;
    params.user_id = userId;
    params.type = type;
    params.page = currentPage;
    params.page_size = pageSize;
    post('/ad-user/finance/detailed', params).then(res => {
      params.is_export = 1;
      let downUrl = BASE_URL + '/ad-user/finance/detailed?' + qs.stringify(params);
      if (res.code === 1) {
        commit(MANAGER_FINANCIAL_DETAILS_TABLE, { data: res.data, url: downUrl });
      }
    });
  }
};

const mutations = {
  [MANAGER_FINANCIAL_DETAILS_MENU] (state, result) {
    state.financial.detailsTypeMenu = result;
    state.financial.curDetailsType = result[0].value;
  },
  [MANAGER_FINANCIAL_DETAILS_TABLE] (state, result) {
    state.financial.detailsPage.setPageData(
      {
        header: result.data.header,
        data: result.data.data,
        total: result.data.count
      },
      false
    );
    state.financial.detailsDown = result.url;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
